export default __webpack_public_path__ + "static/media/discord.e45e3352.svg";